import useAxios from "../../hooks/useAxios";

const usePositionService = () => {
  const axiosGetAllPosition = useAxios();
  const axiosAddPosition = useAxios();
  const axiosEditPosition = useAxios();
  const axiosGetAllApprovers = useAxios();
  const axiosGetAllApproverlessPosition = useAxios();

  const getAllPosition = async (search) => {
    const query = search ? `?search=${encodeURIComponent(search)}` : "";
    await axiosGetAllPosition.fetchData({
      url: `/admin/position${query}`,
      method: "GET",
    });
  };

  const addPosition = async (data) => {
    const result = await axiosAddPosition.fetchData({
      url: `/admin/position/add`,
      method: "POST",
      data,
    });
    return result;
  };

  const editPosition = async (data) => {
    const result = await axiosEditPosition.fetchData({
      url: `/admin/position/edit`,
      method: "POST",
      data,
    });
    return result;
  };

  const getAllApprovers = async () => {
    await axiosGetAllApprovers.fetchData({
      url: `/admin/position/approvers`,
      method: "GET",
    });
  };

  const getAllApproverlessPosition = async () => {
    await axiosGetAllApproverlessPosition.fetchData({
      url: `/admin/position/without-approver`,
      method: "GET",
    });
  };

  return {
    getAllPosition,
    positionLoading: axiosGetAllPosition.loading,
    positionResponse: axiosGetAllPosition.response,
    addPosition,
    addPositionLoading: axiosAddPosition.loading,
    addPositionResponse: axiosAddPosition.response,
    editPosition,
    editPositionLoading: axiosEditPosition.loading,
    editPositionResponse: axiosEditPosition.response,
    getAllApprovers,
    approverLoading: axiosGetAllApprovers.loading,
    approverResponse: axiosGetAllApprovers.response,
    getAllApproverlessPosition,
    approverlessLoading: axiosGetAllApproverlessPosition.loading,
    approverlessResponse: axiosGetAllApproverlessPosition.response,
  };
};

export default usePositionService;
